import React from "react";
import axios from "@/utils/myAxios";
import moment from "moment";
import Cookie from "js-cookie";
import { kindList, sortList, squidTypeList } from "@/utils/constant";
import { Link } from "react-router-dom";
import { getCardUrl } from "@/utils/utils";
import { tableSummaries, isMobileDevice } from "@/utils/utils";
import {
    Table,
    message,
    Row,
    Col,
    Card,
    Modal,
    DatePicker,
    Button,
    InputNumber,
    Pagination,
    Spin,
    Empty,
} from "antd";
import HandDetail from "@/pages/commom/HandDetail";
import HandDetailOfc from "@/pages/commom/HandDetailOfc";

let kindListFilter = kindList.filter(
    (item) => item.value !== 3 && item.value !== 5
);

export default class DerivativeDetection extends React.Component {
    state = {
        loading: false, // 是否加载中
        detailLoading: false, // 手牌详情是否加载中
        show: false, // 是否显示手牌弹窗
        title: undefined, // 弹窗标题
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            uid: undefined,
            dealer: undefined,
            profiteer: undefined,
            date: [],
        },
        detailQueryParams: {
            // 详情查询参数
            page: 1,
            limit: 1,
            total: 0,
        },
        sortList: sortList, // 排序列表
        kindList: kindListFilter, // 游戏类型列表
        squidTypeList: squidTypeList, // 鱿鱼模式
        data: [], // 表格数据
        selectedData: {}, // 选中的表格数据
        handCardData: {}, // 手牌详情
    };

    componentDidMount () {
        this.fetchData();
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/partner/check_point_dealer", {
                params: {
                    ...this.state.queryParams,
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || [],
                });
            });
    };

    /**
     * 获取手牌详情数据
     */
    fetchHandCardData = () => {
        this.setState({ detailLoading: true });
        axios
            .get("/v1/api/union_game_detail", {
                params: {
                    ...this.state.detailQueryParams,
                    mid: this.state.selectedData.mid,
                    hid: this.state.selectedData.hid,
                    total: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    detailLoading: false,
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        total: res.count || 0,
                    },
                    handCardData: res.data || {},
                });
            });
    };

    /**
     * 改变数据分页
     */
    hanldeChangePage = (pagination, type) => {
        if (type === "data") {
            // 数据分页
            this.setState(
                {
                    queryParams: {
                        ...this.state.queryParams,
                        page: pagination.current,
                        limit: pagination.pageSize,
                    },
                },
                () => this.fetchData()
            );
        } else if (type === "handCard") {
            // 手牌详情数据
            this.setState(
                {
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        page: pagination.current,
                    },
                },
                () => this.fetchHandCardData()
            );
        }
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value, type) => {
        if (type === "handCard") {
            this.setState(
                {
                    detailQueryParams: {
                        ...this.state.detailQueryParams,
                        page: 1,
                        [key]: value,
                    },
                },
                () => this.fetchHandCardData()
            );
        } else {
            this.setState({
                queryParams: { ...this.state.queryParams, page: 1, [key]: value },
            });
        }
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    uid: undefined,
                    dealer: undefined,
                    profiteer: undefined,
                    date: [],
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    /**
     * 显示弹窗
     */
    handleShow = (item) => {
        this.setState(
            {
                selectedData: { ...item },
                show: true,
                title: this.props.language["handDetail"],
                handCardData: {},
                detailQueryParams: {
                    ...this.state.detailQueryParams,
                    page: 1,
                    limit: 1,
                },
            },
            () => this.fetchHandCardData()
        );
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <InputNumber
                        precision={0}
                        min={0}
                        max={100000000}
                        placeholder={this.props.language["derivativeInitiatorOrReceiverIdPlaceholder"]}
                        value={this.state.queryParams.uid}
                        onChange={(value) =>
                            this.handleSetQueryParamsData("uid", value, "data")
                        }
                    />
                    <InputNumber
                        precision={0}
                        min={0}
                        max={100000000}
                        placeholder={this.props.language["derivativeInitiatorIdPlaceholder"]}
                        value={this.state.queryParams.dealer}
                        onChange={(value) =>
                            this.handleSetQueryParamsData("dealer", value, "data")
                        }
                    />
                    <InputNumber
                        precision={0}
                        min={0}
                        max={100000000}
                        placeholder={this.props.language["derivativeReceiverIdPlaceholder"]}
                        value={this.state.queryParams.profiteer}
                        onChange={(value) =>
                            this.handleSetQueryParamsData("profiteer", value, "data")
                        }
                    />
                    <DatePicker.RangePicker
                        value={this.state.queryParams.date}
                        onChange={(e) => this.handleSetQueryParamsData("date", e)}
                    />
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={{
                            showTotal: (total) =>
                                `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                            showQuickJumper: true,
                            showSizeChanger: true,
                            size: isMobileDevice() ? 'small' : '',
                            pageSizeOptions: ["10", "20", "30", "40"],
                            current: this.state.queryParams.page,
                            pageSize: this.state.queryParams.limit,
                            total: this.state.queryParams.total,
                        }}
                        loading={this.state.loading}
                        onChange={({ current, pageSize }) =>
                            this.hanldeChangePage({ current, pageSize }, "data")
                        }
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["gambleId"]}
                            dataIndex="mid"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["handCardId"]}
                            dataIndex="hid"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["derivativeInitiatorId"]}
                            dataIndex="dealer"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["derivativeInitiatorName"]}
                            dataIndex="dealer_name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["derivativeReceiverId"]}
                            dataIndex="profiteer"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["derivativeReceiverName"]}
                            dataIndex="profiteer_name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["invertIntegral"]}
                            dataIndex="point"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["blindBet"]}
                            dataIndex="bb"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["invertBlindNumber"]}
                            dataIndex="bb_num"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["gameType"]}
                            dataIndex=""
                            render={(item) =>
                                this.state.kindList.find(
                                    (item2) => item2.value === item.game
                                )
                                    ? this.state.kindList.find(
                                        (item2) => item2.value === item.game
                                    ).label
                                    : ""
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["playCardPepole"]}
                            dataIndex="player_num"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["betPeopleNumber"]}
                            dataIndex="bet_player_num"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cardGameTime"]}
                            dataIndex="start_time"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["exceptionType"]}
                            dataIndex="record_type"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["operation"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : "right"}
                            width={140}
                            render={(item) => (
                                <>
                                    <Button type="default" onClick={() => this.handleShow(item)}>
                                        {this.props.language["handDetail"]}
                                    </Button>
                                </>
                            )}
                        />
                    </Table>
                </div>

                {/* 牌局记录弹窗 */}
                <HandCardModal
                    {...this.props}
                    visible={this.state.show}
                    type={this.state.type}
                    title={this.state.title}
                    loading={this.state.detailLoading}
                    pagination={{
                        showTotal: (total) =>
                            `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                        showQuickJumper: true,
                        current: this.state.detailQueryParams.page,
                        pageSize: this.state.detailQueryParams.limit,
                        total: this.state.detailQueryParams.total,
                        size: isMobileDevice() ? 'small' : '',
                    }}
                    selectedData={this.state.selectedData}
                    handCardData={this.state.handCardData}
                    queryParams={this.state.queryParams}
                    detailQueryParams={this.state.detailQueryParams}
                    handleSetQueryParamsData={this.handleSetQueryParamsData}
                    onCancel={() => this.setState({ show: false })}
                    onChange={(current, pageSize) =>
                        this.hanldeChangePage({ current, pageSize }, "handCard")
                    }
                />
            </div>
        );
    }
}

/**
 * 牌局记录弹窗
 */
class HandCardModal extends React.Component {
    render () {
        let handCardTitle = (
            <div className='container-header p0'>
                {this.props.handCardData.hand_time && (
                    <>
                        <span>{this.props.title}</span>
                        <span>（{this.props.handCardData.id}）</span>
                        <span className="mr20">
                            {this.props.handCardData.hand_time
                                ? this.props.handCardData.hand_time
                                : ""}
                        </span>
                    </>
                )}
            </div>
        );

        return (
            <Modal
                maskClosable={false}
                width={1600}
                title={handCardTitle}
                visible={this.props.visible}
                onCancel={this.props.onCancel}
                centered={isMobileDevice()}
                bodyStyle={{
                    maxHeight: this.props.type === "handCard" ? '60vh' : '70vh',
                    overflowY: "auto",
                }}
                footer={
                    <Pagination
                        {...this.props.pagination}
                        onChange={this.props.onChange}
                    />
                }
            >
                <div className="container-content">
                    {/* 手牌详情 */}
                    <Spin spinning={this.props.loading}>
                        {this.props.handCardData.id && (
                            <>
                                {/* OFC */}
                                {this.props.selectedData.game_kind === 6 && (
                                    <HandDetailOfc
                                        {...this.props}
                                        handCardData={this.props.handCardData}
                                        searchPlayer={{
                                            uid1: this.props.queryParams.dealer || this.props.queryParams.uid,
                                            uid2: this.props.queryParams.profiteer || this.props.queryParams.uid,
                                        }}
                                    />
                                )}

                                {/* NLH, 6+, PLO, AOF */}
                                {this.props.selectedData.game_kind !== 6 && (
                                    <HandDetail
                                        {...this.props}
                                        handCardData={this.props.handCardData}
                                        squidConf={this.props.selectedData.squid_conf}
                                        searchPlayer={{
                                            uid1: this.props.queryParams.dealer || this.props.queryParams.uid,
                                            uid2: this.props.queryParams.profiteer || this.props.queryParams.uid,
                                        }}
                                    />
                                )}
                            </>
                        )}

                        {/* 暂无数据 */}
                        {!this.props.handCardData.id && (
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                        )}
                    </Spin>
                </div>
            </Modal>
        );
    }
}
